import type { IconSvgObject } from './types';

const LessThanCircleIcon: IconSvgObject = [
  ["path", { d: "M13.5 9L10.5 12L13.5 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default LessThanCircleIcon;
